import { Typography } from 'antd';
import React, { useContext } from 'react';
import i18n from '~/i18n';
import { formatCurrency } from '~/utils/currency';
import { CartStateContext } from '~/App/Layout/providers/CartProvider';
import { ShoppingCartOutlined } from '@ant-design/icons';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { OrderContext } from '~/App/Layout/providers/OrderProvider';
import message from '~/utils/message';
import { useGetMenuItemPriceById } from '~/App/hooks/useMenu';
import { checkIsRequireTableNumber } from '@restaurant/constants';
import { OrderType } from '@restaurant/types';

const TotalBar = () => {
  const items = useContext(CartStateContext);
  const navigate = useNavigate();
  const { order } = useContext(OrderContext);
  const getItemPriceById = useGetMenuItemPriceById();

  const total = items.reduce((acc, item) => {
    // Use totalPrice directly if item is a custom.
    if (item.custom) {
      return acc + item.totalPrice;
    }

    acc += getItemPriceById(item.menuId) * item.quantity;
    item.addOns.forEach(({ menuId: addOnId, quantity }) => {
      acc += getItemPriceById(addOnId) * quantity;
    });
    return acc;
  }, 0);
  const isDisabled = items.length === 0;

  const onClick = async () => {
    if (isDisabled) return;
    if (!order.orderType) {
      message.error('Tipe harus diisi!');
      return;
    }

    const isRequireTableNumber = checkIsRequireTableNumber(order.orderType);

    if (
      isRequireTableNumber &&
      (order.tableNumber == null || order.tableNumber == 0)
    ) {
      message.error('Meja harus diisi!');
      return;
    }

    // Validate take away.
    if (
      [OrderType.TakeAway, OrderType.Indent].includes(order.orderType) &&
      (order.customerName == '' || order.customerName == null)
    ) {
      message.error('Nama harus diisi jika takeaway atau indent!');
      return;
    }

    if (order.orderType === OrderType.Indent && !order.delivery) {
      message.error('Detail indent harus diisi');
      return;
    }

    navigate('/cart');
  };

  return (
    <div
      className="total-bar"
      style={{ backgroundColor: isDisabled ? '#c4c4c4' : '#800903' }}
      onClick={onClick}
    >
      <div className="d-flex align-items-center">
        <ShoppingCartOutlined
          style={{ color: 'white', fontSize: 20, marginRight: 8 }}
        />
        <Typography.Title level={5} style={{ color: 'white', margin: 0 }}>
          {i18n.t('menu_total')}
        </Typography.Title>
      </div>
      <Typography.Title level={5} style={{ color: 'white', margin: 0 }}>
        {formatCurrency(total)}
      </Typography.Title>
    </div>
  );
};

export default TotalBar;
